import React, { Fragment } from "react";
import { CentreCol, LeftCol, Row, Tab } from "../..";
import { Card } from "../../Card";
import { TabPane } from "../../Tab";
export var DetailPageContent = function (_a) {
    var tabs = _a.tabs, children = _a.children;
    if (tabs)
        return (React.createElement(DetailPageTabContainer, { tabs: tabs }, children));
    return React.createElement(Fragment, null, children);
};
export var DetailPageTabContainer = function (_a) {
    var tabs = _a.tabs, children = _a.children;
    var handleOnChange = function (eventKey) {
        var item = tabs.items.filter(function (item) { return item.name === eventKey; })[0];
        tabs.onChange && tabs.onChange(item);
    };
    return (React.createElement(Tab.Container, { id: tabs.id, defaultTab: tabs.defaultTab, onChange: handleOnChange },
        React.createElement(Row, null,
            React.createElement(LeftCol, null,
                React.createElement(Card, { title: tabs.title },
                    React.createElement(Tab.Menu, { items: tabs.items, type: "stacked" }))),
            React.createElement(CentreCol, null,
                React.createElement(Tab.Content, null, children)))));
};
export var DetailPageTab = function (_a) {
    var children = _a.children, name = _a.name;
    return (React.createElement(TabPane, { name: name }, children));
};
export var AssistantPanel = function (_a) {
    var children = _a.children;
    return (React.createElement(Fragment, null, children));
};
